export enum BannerAnnouncementType {
  INFO = 'info',
  SUCCESS = 'success',
  CRITICAL = 'critical',
  BLACK_FRIDAY = 'black-friday',
}

export type BannerAnnouncementIconName =
  | 'ui-check-in-circle-v2'
  | 'ui-credit-card-v2'
  | 'ui-document-list'
  | 'ui-info'
  | 'ui-mail'
  | 'ui-person'
  | 'ui-phone'
  | 'ui-pin-location';

/** Icons that should render with fillIconFont=false in fl-banner-announcement. */
export const BANNER_ANNOUNCEMENT_ICONS_NO_FILL: readonly BannerAnnouncementIconName[] =
  ['ui-credit-card-v2', 'ui-document-list'];
